module.exports = __webpack_public_path__ + "static/media/olake-byoc.667f1cca.svg";